import { BlockStack, InlineStack, SkeletonBodyText, SkeletonThumbnail } from '@shopify/polaris';
import React from 'react';
import './skeleton.css';
import { useTranslation } from "react-i18next";

export const rows = [
    {
        key: '1',
        id: <div className='Custom__Order--Skeleton'>
            <BlockStack gap="200">
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <InlineStack gap="100" wrap={false} blockAlign='center'>
                        <SkeletonBodyText lines={1} />
                        <SkeletonThumbnail size="extraSmall" />
                    </InlineStack>
                </InlineStack>
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <InlineStack gap="100" wrap={false} blockAlign='center'>
                        <SkeletonBodyText lines={1} />
                        <SkeletonThumbnail size="extraSmall" />
                    </InlineStack>
                </InlineStack>
            </BlockStack>
        </div>,
        status: <div className='Custom__Status--Skeleton'>
            <BlockStack gap="200">
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <SkeletonBodyText lines={1} />
                </InlineStack>
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <SkeletonBodyText lines={1} />
                </InlineStack>
            </BlockStack>
        </div>,
        sync_status: <div className='Custom__Sync--Skeleton'><SkeletonBodyText lines={1} /></div>,
        ordered_items: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        total_price: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        created_at: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        tags: <div className='Custom__Sync--Skeleton'><SkeletonBodyText lines={1} /></div>,
        actions: <div className='Custom__Action--Skeleton'><InlineStack gap="200">
            <SkeletonThumbnail size="large" />
            <SkeletonThumbnail size="small" />
        </InlineStack>
        </div>,
    },
    {
        key: '2',
        id: <div className='Custom__Order--Skeleton'>
            <BlockStack gap="200">
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <InlineStack gap="100" wrap={false} blockAlign='center'>
                        <SkeletonBodyText lines={1} />
                        <SkeletonThumbnail size="extraSmall" />
                    </InlineStack>
                </InlineStack>
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <InlineStack gap="100" wrap={false} blockAlign='center'>
                        <SkeletonBodyText lines={1} />
                        <SkeletonThumbnail size="extraSmall" />
                    </InlineStack>
                </InlineStack>
            </BlockStack>
        </div>,
        status: <div className='Custom__Status--Skeleton'>
            <BlockStack gap="200">
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <SkeletonBodyText lines={1} />
                </InlineStack>
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <SkeletonBodyText lines={1} />
                </InlineStack>
            </BlockStack>
        </div>,
        sync_status: <div className='Custom__Sync--Skeleton'><SkeletonBodyText lines={1} /></div>,
        ordered_items: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        total_price: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        created_at: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        tags: <div className='Custom__Sync--Skeleton'><SkeletonBodyText lines={1} /></div>,
        actions: <div className='Custom__Action--Skeleton'><InlineStack gap="200">
            <SkeletonThumbnail size="large" />
            <SkeletonThumbnail size="small" />
        </InlineStack>
        </div>,
    },
    {
        key: '3',
        id: <div className='Custom__Order--Skeleton'>
            <BlockStack gap="200">
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <InlineStack gap="100" wrap={false} blockAlign='center'>
                        <SkeletonBodyText lines={1} />
                        <SkeletonThumbnail size="extraSmall" />
                    </InlineStack>
                </InlineStack>
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <InlineStack gap="100" wrap={false} blockAlign='center'>
                        <SkeletonBodyText lines={1} />
                        <SkeletonThumbnail size="extraSmall" />
                    </InlineStack>
                </InlineStack>
            </BlockStack>
        </div>,
        status: <div className='Custom__Status--Skeleton'>
            <BlockStack gap="200">
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <SkeletonBodyText lines={1} />
                </InlineStack>
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <SkeletonBodyText lines={1} />
                </InlineStack>
            </BlockStack>
        </div>,
        sync_status: <div className='Custom__Sync--Skeleton'><SkeletonBodyText lines={1} /></div>,
        ordered_items: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        total_price: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        created_at: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        tags: <div className='Custom__Sync--Skeleton'><SkeletonBodyText lines={1} /></div>,
        actions: <div className='Custom__Action--Skeleton'><InlineStack gap="200">
            <SkeletonThumbnail size="large" />
            <SkeletonThumbnail size="small" />
        </InlineStack>
        </div>,
    },
    {
        key: '4',
        id: <div className='Custom__Order--Skeleton'>
            <BlockStack gap="200">
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <InlineStack gap="100" wrap={false} blockAlign='center'>
                        <SkeletonBodyText lines={1} />
                        <SkeletonThumbnail size="extraSmall" />
                    </InlineStack>
                </InlineStack>
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <InlineStack gap="100" wrap={false} blockAlign='center'>
                        <SkeletonBodyText lines={1} />
                        <SkeletonThumbnail size="extraSmall" />
                    </InlineStack>
                </InlineStack>
            </BlockStack>
        </div>,
        status: <div className='Custom__Status--Skeleton'>
            <BlockStack gap="200">
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <SkeletonBodyText lines={1} />
                </InlineStack>
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <SkeletonBodyText lines={1} />
                </InlineStack>
            </BlockStack>
        </div>,
        sync_status: <div className='Custom__Sync--Skeleton'><SkeletonBodyText lines={1} /></div>,
        ordered_items: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        total_price: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        created_at: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        tags: <div className='Custom__Sync--Skeleton'><SkeletonBodyText lines={1} /></div>,
        actions: <div className='Custom__Action--Skeleton'><InlineStack gap="200">
            <SkeletonThumbnail size="large" />
            <SkeletonThumbnail size="small" />
        </InlineStack>
        </div>,
    },
    {
        key: '5',
        id: <div className='Custom__Order--Skeleton'>
            <BlockStack gap="200">
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <InlineStack gap="100" wrap={false} blockAlign='center'>
                        <SkeletonBodyText lines={1} />
                        <SkeletonThumbnail size="extraSmall" />
                    </InlineStack>
                </InlineStack>
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <InlineStack gap="100" wrap={false} blockAlign='center'>
                        <SkeletonBodyText lines={1} />
                        <SkeletonThumbnail size="extraSmall" />
                    </InlineStack>
                </InlineStack>
            </BlockStack>
        </div>,
        status: <div className='Custom__Status--Skeleton'>
            <BlockStack gap="200">
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <SkeletonBodyText lines={1} />
                </InlineStack>
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <SkeletonBodyText lines={1} />
                </InlineStack>
            </BlockStack>
        </div>,
        sync_status: <div className='Custom__Sync--Skeleton'><SkeletonBodyText lines={1} /></div>,
        ordered_items: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        total_price: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        created_at: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        tags: <div className='Custom__Sync--Skeleton'><SkeletonBodyText lines={1} /></div>,
        actions: <div className='Custom__Action--Skeleton'><InlineStack gap="200">
            <SkeletonThumbnail size="large" />
            <SkeletonThumbnail size="small" />
        </InlineStack>
        </div>,
    },
    {
        key: '6',
        id: <div className='Custom__Order--Skeleton'>
            <BlockStack gap="200">
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <InlineStack gap="100" wrap={false} blockAlign='center'>
                        <SkeletonBodyText lines={1} />
                        <SkeletonThumbnail size="extraSmall" />
                    </InlineStack>
                </InlineStack>
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <InlineStack gap="100" wrap={false} blockAlign='center'>
                        <SkeletonBodyText lines={1} />
                        <SkeletonThumbnail size="extraSmall" />
                    </InlineStack>
                </InlineStack>
            </BlockStack>
        </div>,
        status: <div className='Custom__Status--Skeleton'>
            <BlockStack gap="200">
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <SkeletonBodyText lines={1} />
                </InlineStack>
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <SkeletonBodyText lines={1} />
                </InlineStack>
            </BlockStack>
        </div>,
        sync_status: <div className='Custom__Sync--Skeleton'><SkeletonBodyText lines={1} /></div>,
        ordered_items: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        total_price: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        created_at: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        tags: <div className='Custom__Sync--Skeleton'><SkeletonBodyText lines={1} /></div>,
        actions: <div className='Custom__Action--Skeleton'><InlineStack gap="200">
            <SkeletonThumbnail size="large" />
            <SkeletonThumbnail size="small" />
        </InlineStack>
        </div>,
    },
    {
        key: '7',
        id: <div className='Custom__Order--Skeleton'>
            <BlockStack gap="200">
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <InlineStack gap="100" wrap={false} blockAlign='center'>
                        <SkeletonBodyText lines={1} />
                        <SkeletonThumbnail size="extraSmall" />
                    </InlineStack>
                </InlineStack>
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <InlineStack gap="100" wrap={false} blockAlign='center'>
                        <SkeletonBodyText lines={1} />
                        <SkeletonThumbnail size="extraSmall" />
                    </InlineStack>
                </InlineStack>
            </BlockStack>
        </div>,
        status: <div className='Custom__Status--Skeleton'>
            <BlockStack gap="200">
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <SkeletonBodyText lines={1} />
                </InlineStack>
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <SkeletonBodyText lines={1} />
                </InlineStack>
            </BlockStack>
        </div>,
        sync_status: <div className='Custom__Sync--Skeleton'><SkeletonBodyText lines={1} /></div>,
        ordered_items: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        total_price: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        created_at: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        tags: <div className='Custom__Sync--Skeleton'><SkeletonBodyText lines={1} /></div>,
        actions: <div className='Custom__Action--Skeleton'><InlineStack gap="200">
            <SkeletonThumbnail size="large" />
            <SkeletonThumbnail size="small" />
        </InlineStack>
        </div>,
    },
    {
        key: '8',
        id: <div className='Custom__Order--Skeleton'>
            <BlockStack gap="200">
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <InlineStack gap="100" wrap={false} blockAlign='center'>
                        <SkeletonBodyText lines={1} />
                        <SkeletonThumbnail size="extraSmall" />
                    </InlineStack>
                </InlineStack>
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <InlineStack gap="100" wrap={false} blockAlign='center'>
                        <SkeletonBodyText lines={1} />
                        <SkeletonThumbnail size="extraSmall" />
                    </InlineStack>
                </InlineStack>
            </BlockStack>
        </div>,
        status: <div className='Custom__Status--Skeleton'>
            <BlockStack gap="200">
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <SkeletonBodyText lines={1} />
                </InlineStack>
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <SkeletonBodyText lines={1} />
                </InlineStack>
            </BlockStack>
        </div>,
        sync_status: <div className='Custom__Sync--Skeleton'><SkeletonBodyText lines={1} /></div>,
        ordered_items: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        total_price: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        created_at: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        tags: <div className='Custom__Sync--Skeleton'><SkeletonBodyText lines={1} /></div>,
        actions: <div className='Custom__Action--Skeleton'><InlineStack gap="200">
            <SkeletonThumbnail size="large" />
            <SkeletonThumbnail size="small" />
        </InlineStack>
        </div>,
    },
    {
        key: '9',
        id: <div className='Custom__Order--Skeleton'>
            <BlockStack gap="200">
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <InlineStack gap="100" wrap={false} blockAlign='center'>
                        <SkeletonBodyText lines={1} />
                        <SkeletonThumbnail size="extraSmall" />
                    </InlineStack>
                </InlineStack>
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <InlineStack gap="100" wrap={false} blockAlign='center'>
                        <SkeletonBodyText lines={1} />
                        <SkeletonThumbnail size="extraSmall" />
                    </InlineStack>
                </InlineStack>
            </BlockStack>
        </div>,
        status: <div className='Custom__Status--Skeleton'>
            <BlockStack gap="200">
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <SkeletonBodyText lines={1} />
                </InlineStack>
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <SkeletonBodyText lines={1} />
                </InlineStack>
            </BlockStack>
        </div>,
        sync_status: <div className='Custom__Sync--Skeleton'><SkeletonBodyText lines={1} /></div>,
        ordered_items: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        total_price: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        created_at: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        tags: <div className='Custom__Sync--Skeleton'><SkeletonBodyText lines={1} /></div>,
        actions: <div className='Custom__Action--Skeleton'><InlineStack gap="200">
            <SkeletonThumbnail size="large" />
            <SkeletonThumbnail size="small" />
        </InlineStack>
        </div>,
    },
    {
        key: '10',
        id: <div className='Custom__Order--Skeleton'>
            <BlockStack gap="200">
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <InlineStack gap="100" wrap={false} blockAlign='center'>
                        <SkeletonBodyText lines={1} />
                        <SkeletonThumbnail size="extraSmall" />
                    </InlineStack>
                </InlineStack>
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <InlineStack gap="100" wrap={false} blockAlign='center'>
                        <SkeletonBodyText lines={1} />
                        <SkeletonThumbnail size="extraSmall" />
                    </InlineStack>
                </InlineStack>
            </BlockStack>
        </div>,
        status: <div className='Custom__Status--Skeleton'>
            <BlockStack gap="200">
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <SkeletonBodyText lines={1} />
                </InlineStack>
                <InlineStack gap="200" wrap={false} blockAlign='center'>
                    <SkeletonThumbnail size="extraSmall" />
                    <SkeletonBodyText lines={1} />
                </InlineStack>
            </BlockStack>
        </div>,
        sync_status: <div className='Custom__Sync--Skeleton'><SkeletonBodyText lines={1} /></div>,
        ordered_items: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        total_price: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        created_at: <div className='Custom__Order1--Skeleton'><SkeletonBodyText lines={1} /></div>,
        tags: <div className='Custom__Sync--Skeleton'><SkeletonBodyText lines={1} /></div>,
        actions: <div className='Custom__Action--Skeleton'><InlineStack gap="200">
            <SkeletonThumbnail size="large" />
            <SkeletonThumbnail size="small" />
        </InlineStack>
        </div>,
    }
];